<header class="modal-header">
  <h1 class="h3 modal-title">
    <ng-container *ngIf="adaptToStudyProgram; else noAdaptToStudyProgram" i18n
      >Wybieranie programu studiów studenta</ng-container
    >
    <ng-template #noAdaptToStudyProgram>
      {{ config.modalTitle }}
    </ng-template>
    <ng-container *ngIf="!adaptToStudyProgram && !config.modalTitle" i18n>Wybieranie osoby</ng-container>
  </h1>
  <button
    ndt-icon-button
    type="button"
    [disabled]="isSaving"
    class="text-secondary-500 hover:opacity-75"
    aria-label="Zamknij"
    i18n-aria-label
    (click)="modalRef.hide()"
  >
    <app-icon name="close"></app-icon>
  </button>
</header>

<div *ngIf="formFilters" class="modal-body">
  <form *ngIf="!config.hiddenFilters" class="mb-6" [formGroup]="formFilters" (ngSubmit)="submitFilters()">
    <div
      class="mb-6 grid grid-flow-col"
      [ngClass]="getFieldsNumber() >= 4 ? 'grid-cols-4' : 'auto-cols-auto grid-cols-none'"
    >
      <ng-container *ngFor="let item of config.fields">
        <span *ngIf="!item.noFilter">
          <label for="{{ item.propsName }}-input" class="form-label">{{ item.placeholder }}</label>
          <input
            id="{{ item.propsName }}-input"
            class="form-control"
            type="text"
            autocomplete="off"
            [placeholder]="item.placeholder"
            [formControlName]="item.propsName"
          />
        </span>
      </ng-container>

      <span *ngFor="let item of config.comboboxFields; let i = index">
        <label class="form-label">{{ item.placeholder }}</label>
        <app-select
          [data]="comboboxItems[i]"
          [displayProperty]="[item.propToDisplay]"
          [reactiveControl]="formFilters.get(item.propSearchName)"
          [valueProperty]="item.propToReturn"
        ></app-select>
      </span>
    </div>
    <div class="flex justify-end gap-4">
      <button ndt-tertiary-button type="button" (click)="resetFilters()" i18n>Wyczyść</button>
      <button ndt-secondary-button type="submit" [disabled]="isLoadingData" i18n>Szukaj</button>
    </div>
  </form>

  <app-domain-error class="mb-6"></app-domain-error>
  <div class="list-wrapper">
    <table class="table-striped table">
      <thead>
        <tr>
          <th scope="col" class="table__actions-col"></th>
          <th scope="col" *ngFor="let item of config.fields">
            {{ item.placeholder }}
          </th>
          <th scope="col" *ngFor="let item of config.comboboxFields">
            {{ item.placeholder }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="(persons && !persons.length) || !totalItems">
          <td [attr.colspan]="getFieldsNumber() + 1">
            <app-no-results></app-no-results>
          </td>
        </tr>
        <tr *ngFor="let item of persons; trackBy: trackBy" (click)="toggleSelectedPerson(item)">
          <td>
            <input
              [type]="config.multipleSelection ? 'checkbox' : 'radio'"
              [checked]="item.isSelected"
              [(ngModel)]="item.isSelected"
              class="form-check-input"
              title="Zaznacz / odznacz rekord"
              i18n-title
            />
          </td>
          <td *ngFor="let element of config.fields" [innerHTML]="item[element.propsName]"></td>
          <td *ngFor="let element of config.comboboxFields" [innerHTML]="item[element.propsName]"></td>
        </tr>
      </tbody>
    </table>
  </div>
  <app-list-footer
    [page]="page"
    [pageSize]="pageSize"
    [totalItems]="totalItems"
    (loadRecords)="getRecords($event)"
    (changeListSize)="changeListSize($event)"
  ></app-list-footer>
</div>

<footer class="modal-footer">
  <button ndt-tertiary-button type="button" (click)="modalRef.hide()" i18n>Anuluj</button>
  <button ndt-primary-button type="button" [disabled]="isSaving || !selectedPersons.length" (click)="submit()" i18n>
    Zatwierdź
  </button>
</footer>
